var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.mode,_vm._g(_vm._b({ref:_vm.refId,tag:"component",attrs:{"obj":_vm.obj}},'component',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }